import makeRequest, {HttpMethod, Request} from "./request";
import {recordToken, removeToken, removeTokenTmp} from "../Storages/cookies";
import {authData, listAdminModulesActions} from "../Storages";

const verifyTwoFactorCode: Request = makeRequest('verify-two-factor-code')
    .swapAuthorizationTempHeader()
    .prepare(async (params: object) => {
        const {data, response, method} = params as { data: any; response: any, method: HttpMethod };

        removeToken(); //apenas precaução

        let newAttemptAllowed = true;

        if (data?.status === "success") {
            recordToken();
            verifyTwoFactorCode.clearAllowedErrors();
        } else {
            verifyTwoFactorCode.addErrorToCount()
            if(verifyTwoFactorCode.getCountErrors() > 2) {
                removeTokenTmp();
                authData.remove();
                listAdminModulesActions.remove();
                newAttemptAllowed = false;
                verifyTwoFactorCode.clearAllowedErrors(); //precaução
            }
        }

        const errors = { newAttemptAllowed }

        return {
            data: { ...data, ...errors },
            response,
            method
        };
    });

export default verifyTwoFactorCode;